module.exports = __webpack_public_path__ + "static/media/desktop.a202e73a.ini";